<template>
  <div class="mt-6 mb-6 sm:mb-8">
    <h1 class="text-2xl sm:text-3xl font-bold text-neutral-950 mb-2 leading-tight">{{ title }}</h1>
    <p class="text-sm sm:text-base text-neutral-600">{{ subtitle }}</p>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  }
});
</script>
